import { headingCID } from '../../components/Heading';

const fontFaces = [
  {
    '@font-face': {
      fontFamily: 'trade-gothic-next',
      src: 'url("https://use.typekit.net/af/f82cc1/00000000000000007735ba3f/31/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff2"),url("https://use.typekit.net/af/f82cc1/00000000000000007735ba3f/31/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff"),url("https://use.typekit.net/af/f82cc1/00000000000000007735ba3f/31/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("opentype")',
      fontDisplay: 'swap',
      fontStyle: 'normal',
      fontWeight: 700,
      fontStretch: 'normal',
    },
  },
  {
    '@font-face': {
      fontFamily: 'trade-gothic-next',
      src: 'url("https://use.typekit.net/af/29fcc8/00000000000000007735ba6d/31/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff2"),url("https://use.typekit.net/af/29fcc8/00000000000000007735ba6d/31/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff"),url("https://use.typekit.net/af/29fcc8/00000000000000007735ba6d/31/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("opentype")',
      fontDisplay: 'swap',
      fontStyle: 'italic',
      fontWeight: 700,
      fontStretch: 'normal',
    },
  },
  {
    '@font-face': {
      fontFamily: 'trade-gothic-next',
      src: 'url("https://use.typekit.net/af/8d0537/00000000000000007735ba61/31/l?subset_id=2&fvd=n8&v=3") format("woff2"),url("https://use.typekit.net/af/8d0537/00000000000000007735ba61/31/d?subset_id=2&fvd=n8&v=3") format("woff"),url("https://use.typekit.net/af/8d0537/00000000000000007735ba61/31/a?subset_id=2&fvd=n8&v=3") format("opentype")',
      fontDisplay: 'swap',
      fontStyle: 'normal',
      fontWeight: 800,
      fontStretch: 'normal',
    },
  },
  {
    '@font-face': {
      fontFamily: 'trade-gothic-next',
      src: 'url("https://use.typekit.net/af/685cbf/00000000000000007735ba65/31/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("woff2"),url("https://use.typekit.net/af/685cbf/00000000000000007735ba65/31/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("woff"),url("https://use.typekit.net/af/685cbf/00000000000000007735ba65/31/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("opentype")',
      fontDisplay: 'swap',
      fontStyle: 'italic',
      fontWeight: 400,
      fontStretch: 'normal',
    },
  },
  {
    '@font-face': {
      fontFamily: 'trade-gothic-next',
      src: 'url("https://use.typekit.net/af/b78836/00000000000000007735ba66/31/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff2"),url("https://use.typekit.net/af/b78836/00000000000000007735ba66/31/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff"),url("https://use.typekit.net/af/b78836/00000000000000007735ba66/31/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("opentype")',
      fontDisplay: 'swap',
      fontStyle: 'normal',
      fontWeight: 400,
      fontStretch: 'normal',
    },
  },
  {
    '@font-face': {
      fontFamily: 'trade-gothic-next-condensed',
      src: 'url("https://use.typekit.net/af/ca2d73/00000000000000007735ba43/31/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff2"),url("https://use.typekit.net/af/ca2d73/00000000000000007735ba43/31/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff"),url("https://use.typekit.net/af/ca2d73/00000000000000007735ba43/31/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("opentype")',
      fontDisplay: 'swap',
      fontStyle: 'normal',
      fontWeight: 700,
      fontStretch: 'normal',
    },
  },
  {
    '@font-face': {
      fontFamily: 'trade-gothic-next-condensed',
      src: 'url("https://use.typekit.net/af/bc481b/00000000000000007735ba54/31/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n8&v=3") format("woff2"),url("https://use.typekit.net/af/bc481b/00000000000000007735ba54/31/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n8&v=3") format("woff"),url("https://use.typekit.net/af/bc481b/00000000000000007735ba54/31/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n8&v=3") format("opentype")',
      fontDisplay: 'swap',
      fontStyle: 'normal',
      fontWeight: 800,
      fontStretch: 'normal',
    },
  },
];

const components = [
  () => ({
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: '"trade-gothic-next-condensed", "Helvetica Neue", "Arial", sans-serif',
          fontWeight: 900,
          textTransform: 'uppercase',
        },
        sizeMedium: {
          fontSize: '1.1rem',
        },
        contained: {
          background: '#000',
          '&:hover': {
            background: '#FFAACC',
            color: '#000',
            boxShadow: 'unset',
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'uppercase',
          fontSize: '1rem',
          color: 'black',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontFamily: '"trade-gothic-next-condensed", "Helvetica Neue", "Arial", sans-serif',
          fontWeight: 900,
          fontSize: '1rem',
          textTransform: 'uppercase',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          '& img': {
            padding: '0.75rem',
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        'h1, h2, h3, h4, h5, h6': {
          fontFamily: '"trade-gothic-next-condensed", "Helvetica Neue", "Arial", sans-serif',
          textTransform: 'uppercase',
          fontWeight: 900,
        },
        html: {
          fallbacks: fontFaces,
          'h1, h2, h3': {
            [`&.${headingCID}`]: {
              fontFamily: '"trade-gothic-next-condensed", "Helvetica Neue", "Arial", sans-serif',
              fontWeight: '900 !important',
              textTransform: 'uppercase',
            },
          },
        },
      },
    },
  }),
];

const palette = {
  background: {
    default: '#DDFFDD',
  },
  breadcrumbs: {
    background: '#FFDDEE',
  },
  link: {
    header: undefined,
    text: '#05aa02',
  },
  primary: {
    main: '#05aa02',
  },
  secondary: {
    main: '#05aa02',
  },
  tertiary: {
    contrastText: '#000',
    main: '#DDFFDD',
  },
  divider: '#FFAACC',
  heading: '#000',
};

const typography = {
  fontFamily: '"trade-gothic-next", "Helvetica Neue", "Arial", sans-serif',
  eventsIcon: {
    fontFamily: 'sans-serif',
  },
  button: {
    fontFamily: '"trade-gothic-next-condensed", "Helvetica Neue", "Arial", sans-serif',
    fontWeight: 800,
    textTransform: 'uppercase',
  },
  fontSizes: {
    xSmall: '.85em',
    small: '.95em',
    medium: '1.1em',
    large: '1.225em',
    xLarge: '1.3em',
    xxLarge: '2em',
  },
  fontWeightMedium: 800,
};

export default {
  components,
  variables: {
    appBar: { background: 'tertiary' },
    navBarFontSize: '1rem',
    palette,
    typography,
  },
};
